import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useOmnistore } from '../stores/Omnistore';

export const LocationStoreLifecycle = observer((props: {}) => {
	const omnistore = useOmnistore();
	const reoctoStore = omnistore.reoctoStore;
	const authStore = omnistore.authStore;
	const multirepo = omnistore.multirepo;
	const locationStore = omnistore.locationStore;
	let	shouldPushState = true;
	React.useEffect(() => autorun(() => {
		if (!multirepo.branchRepo.length) return;
		if (multirepo.branchRepo.byId(locationStore.branchId)) return;
		locationStore.setBranchId(multirepo.branchRepo.allAsList.map(e => e.id)[0]);
	}));
	React.useEffect(() => {
		try {
			locationStore.applyUrl(window.location.hash);
		} catch (e) {
			console.log(e);
		}
		if (!reoctoStore.honorLocation && authStore.role==='STANDARD') locationStore.applyUrl('GDashboard');
	});
	React.useEffect(() => autorun(() => {
		if (shouldPushState) {
			window.history.pushState('', '', '#!/' + locationStore.urlHash);
		} else {
			shouldPushState = true;
		}
	}));
	React.useEffect(() => autorun(() => {
		window.document.title = locationStore.documentTitle;
	}));
	window.onhashchange = () => {
		shouldPushState = false;
		locationStore.applyUrl(window.location.hash);
	};
	return null;
});
